var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterSquareDarkBlue = function SvgTwitterSquareDarkBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00586C",
    d: "M20.75 2H4.25A2.25 2.25 0 0 0 2 4.25v16.5A2.25 2.25 0 0 0 4.25 23h16.5A2.25 2.25 0 0 0 23 20.75V4.25A2.25 2.25 0 0 0 20.75 2m-2.292 7.444c.01.131.01.267.01.398 0 4.064-3.095 8.747-8.748 8.747A8.7 8.7 0 0 1 5 17.211c.248.028.487.037.74.037 1.44 0 2.762-.487 3.816-1.312a3.08 3.08 0 0 1-2.873-2.133c.473.07.9.07 1.387-.056a3.075 3.075 0 0 1-2.46-3.019v-.037c.407.23.885.37 1.387.389a3.07 3.07 0 0 1-1.369-2.56c0-.572.15-1.097.417-1.551a8.73 8.73 0 0 0 6.338 3.215c-.436-2.086 1.125-3.778 3-3.778.886 0 1.683.37 2.245.97a6 6 0 0 0 1.95-.74 3.07 3.07 0 0 1-1.35 1.692A6.1 6.1 0 0 0 20 7.85a6.5 6.5 0 0 1-1.542 1.594"
  })));
};
export default SvgTwitterSquareDarkBlue;